import React from "react";
import { IIcons } from "./icons";

const CircleMinus = ({ fillColor }: IIcons.IconProps) => {
  return (
    <svg
      width="13"
      height="3"
      viewBox="0 0 13 3"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={fillColor}
    >
      <rect
        x="13"
        y="0.735352"
        width="1.52941"
        height="13"
        rx="0.764706"
        transform="rotate(90 13 0.735352)"
        fill="#000000"
      />
    </svg>
  );
};

export default CircleMinus;
